<div class="fading-modal">
    <h4>Please press 'ESC' to exit fullscreen mode.</h4>
</div>